<button mat-icon-button (click)="showNav = !showNav">
  <mat-icon>menu</mat-icon>
</button>

@if (showNav) {
  <div class="left-0 w-64 bg-white z-50 transition-transform transform">
    <mat-nav-list class="flex flex-col p-2 space-y-1">
      
      <a 
        mat-list-item 
        routerLink="/" 
        class="flex items-center px-4 py-2 rounded hover:bg-gray-200">
        <mat-icon class="mr-4 text-lg">dashboard</mat-icon>
        <span class="text-base">Dashboard</span>
      </a>

      <mat-expansion-panel class="mat-elevation-z0" hideToggle [expanded]="true">
        <mat-expansion-panel-header class="flex items-center !p-4 py-2 rounded hover:bg-gray-200 cursor-pointer">
          <mat-icon class="mr-4 text-lg">folder</mat-icon>
          <span class="text-base font-normal">Repositories</span>
          <mat-icon class="ml-auto">expand_more</mat-icon>
        </mat-expansion-panel-header>

        <mat-nav-list class="flex flex-col pl-8">
          <a
            mat-list-item
            *ngFor="let rep of repositories"
            [routerLink]="['/repository', rep.id]"
            class="flex items-center px-4 py-2 rounded hover:bg-gray-100">
            <mat-icon class="mr-4 text-lg">folder</mat-icon>
            <span class="text-sm">{{ rep.name }}</span>
          </a>
        </mat-nav-list>
      </mat-expansion-panel>
      
    </mat-nav-list>
  </div>
}